import { useState } from "react";
import { toast } from "sonner";
import { p, errMsg } from "@/lib/api";
import { useI18n } from "@/i18n";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { LifeBuoy } from "lucide-react";

/** «Ho perso il codice»: l'accesso torna per email, senza chiedere niente a nessuno. */
export const RecuperaCodice = ({ open, onOpenChange }) => {
  const { t } = useI18n();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const send = async () => {
    setBusy(true);
    try {
      await p("/tenant/recover", { email: email.trim() });
      setSent(true);
    } catch (e) {
      toast.error(errMsg(e));
    }
    setBusy(false);
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { onOpenChange(v); if (!v) { setSent(false); setEmail(""); } }}>
      <DialogContent className="max-w-md" data-testid="recover-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <LifeBuoy className="h-5 w-5" /> {t("rec.title")}
          </DialogTitle>
          <DialogDescription>{sent ? t("rec.done") : t("rec.sub")}</DialogDescription>
        </DialogHeader>

        {!sent ? (
          <div className="space-y-3">
            <Input
              className="h-12"
              type="email"
              placeholder={t("rec.email")}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && email.trim() && send()}
              data-testid="recover-email-input"
            />
            <Button className="h-12 w-full" disabled={busy || !email.trim()} onClick={send} data-testid="recover-send-btn">
              {t("rec.send")}
            </Button>
            <p className="text-xs text-slate-500">{t("rec.note")}</p>
          </div>
        ) : (
          <Button className="h-12 w-full" onClick={() => onOpenChange(false)} data-testid="recover-close-btn">
            {t("rec.ok")}
          </Button>
        )}
      </DialogContent>
    </Dialog>
  );
};
